import { Box, Divider, Typography } from "@mui/material"
import { DeviceResultsList } from "components/DeviceResultsList/DeviceResultsList"
import { MiniGalery } from "components/MiniGalery.tsx/MiniGalery"
import { CriteriaCatalog, TestData } from "graphql/types"

type TaskFunctionCardProps = {
  testData: TestData
  criteriaCatalog: CriteriaCatalog[]
}

export const TaskFunctionCard = (props: TaskFunctionCardProps) => {
  const { testData, criteriaCatalog } = props

  return (
    <>
      <Typography variant="body2">{testData.description}</Typography>

      {testData.deviceTestData?.map((item) => (
        <Box key={item.device.id} sx={{ mt: 2 }}>
          <DeviceResultsList deviceTestData={item} criteriaCatalog={criteriaCatalog} />
          <Typography variant="body2">{item.note}</Typography>

          <MiniGalery images={item.images} deleteButton={false} />
          <Divider sx={{ mt: -2 }} />
        </Box>
      ))}
    </>
  )
}
